export default __webpack_public_path__ + "static/media/helecopter.4c13ac63.webp";